/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Auth from "../pages/auth";
import { useApp } from "../contexts";
import WalletList from "../pages/wallet-list";
import Header from "../components/Layout/header.main";
import WalletDetail from "../pages/wallet-detail-history";
import WalletDetailHistory from "../pages/wallet-detail-history-old";
import Withdraw from "../pages/withdraw";
import TransferWeb3 from "../pages/transfer-web3";
import TransactionHistory from "../pages/transaction-history";
import Stake from "../pages/stake";
import Commission from "../pages/commission";
import CommissionDetail from "../pages/commission-detail";
import { StakeDetail } from "../pages/stake-detail";
import StakeSuccess from "../pages/stake-success";
import Footer from "../components/Layout/footer";
import ConfirmPhone from "../pages/confirm-phone";
import { getInfoByCodeSSO } from "../services/app";
import { CountryCode, DOMAIN_COOKIE, KEY_COOKIE } from "../constants";
import { Logout } from "../pages/logout";
import { getCookie, setCookie } from "../utils/helper";
import { LoadingSplash2 } from "../components/Loading2";
import { Home } from "../pages/Home";
import { ChangePassword } from "../pages/change-password";
import { TwoFactor } from "../pages/two-factor";
import { Profile } from "../pages/profile";
import { MyPurchase } from "../pages/my-purchase";
import { Asset } from "../pages/asset";
import { EarnerDetail } from "../pages/earner-detail";
import { CharacterDetail } from "../pages/character-detail";
import { ClaimGift } from "../pages/claim-gift";
import { CardInfo } from "../pages/card-info";
import { Affiliate } from "../pages/Affiliate";
import { AffiliateGenerate } from "../pages/affiliate-generate";
import { SetPassword } from "../pages/set-password";
import AddressBook from "../pages/address-book";
import MintNFT from "../pages/mint-nft";
import ClaimSot from "../pages/claim-sot";
import WithDrawSGT from "../pages/withdraw-sgt/components/WithDrawSGT";
import { PaymentMethod } from "../pages/payment-method";
import StakeSgt from "../pages/stake-sgt";
import { StakeForOption } from "../pages/stake-for-option/StakeForOption";
import { StakeHistory } from "../pages/wallet-list/components/StakeHistory";
import VerifyPhone from "../components/VerifyPhone";
export default function AppRouter(props) {
  const { user, setUser, reloadProfile } =
    useApp();
  const location = useLocation();
  const [isReadyRender, setIsReadyRender] = useState(false);
  

  const sso_token = getCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE)?.access_token;
  let params = new URLSearchParams(window.location.search);
  let code = params.get("code");

  useEffect(() => {
    if (code?.length > 20) {
      getInfoByCodeSSO(code).then((res) => {
        setUser({
          token: res?.data?.data?.data?.access_token,
          refreshToken: res?.data?.data?.data?.refresh_token,
          token_sso: res?.data?.data?.data?.access_token,
          reload: Date.now(),
        });
        if (process.env.NODE_ENV === "development") {
          const cookieData = JSON.stringify({
            id_token: "",
            access_token: res?.data?.data?.data?.access_token || "",
            refresh_token: res?.data?.data?.data?.refresh_token || "",
            expires_in: res.data?.expiresIn || 1718875995000,
            token_type: "Bearer",
            user: {},
          });
          setCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE, cookieData, {
            domain: DOMAIN_COOKIE,
            maxAge: Date.now() + 36135 * 86400000,
          });
        }
        if (typeof window?.history?.pushState === 'function') {
            let urlCurrent = window.location.href;
            urlCurrent = urlCurrent.replace(`?code=${code}`, "");
            urlCurrent = urlCurrent.replace(`&code=${code}`, "");
            window.history.pushState({path:urlCurrent},'',urlCurrent);
        }
        setIsReadyRender(true);
      });
    } else {
      setIsReadyRender(true);
    }
  }, [code, setUser]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!user?.token) return;
    reloadProfile();
  }, [location]);

  if (!isReadyRender) {
    return <LoadingSplash2 />;
  }

  if (!user?.token) {
    return (
      <>
        <Header isAuth={false} />
        <Routes>
          <Route path={"/*"} element={<Auth />} />
        </Routes>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header isAuth={true} />
      <Routes>
        <Route path={"/"} element={<Home />} />
        <Route path={"/wallet"} element={<WalletList />} />
        <Route path={"/stake-for-option"} element={<StakeForOption />} />
        <Route path={"/stake-for-option-history"} element={<StakeHistory />} />
        <Route path={"/logout"} element={<Logout />} />
        <Route path={"/wallet-detail/:type"} element={<WalletDetail />} />
        <Route
          path={"/wallet-detail-history"}
          element={<WalletDetailHistory />}
        />
        <Route
          path={"/withdraw/:optionCoin/:optionWalletId"}
          element={<Withdraw />}
        />
        <Route path={"/withdraw"} element={<Withdraw />} />
        <Route path={"/claim-sot"} element={<ClaimSot />} />
        <Route path={"/withdraw-sgt"} element={<WithDrawSGT />} />
        <Route path={"/transfer-web3"} element={<TransferWeb3 />} />
        <Route path={"/stake"} element={<Stake />} />
        <Route path={"/mint-nft"} element={<MintNFT />} />
        <Route path={"/asset"} element={<Asset />} />
        <Route path={"/earner-detail/:id"} element={<EarnerDetail />} />
        <Route path={"/character-detail/:id"} element={<CharacterDetail />} />
        
        <Route path={"/change-password"} element={<ChangePassword />} />

        <Route path={"/payment-method"} element={<PaymentMethod />} />
        <Route path={"/set-password"} element={<SetPassword />} />
        <Route path={"/address-book"} element={<AddressBook />} />
        <Route path={"/claim-gifts"} element={<ClaimGift />} />
        <Route path={"/two-factor"} element={<TwoFactor />} />
        <Route path={"/profile"} element={<Profile />} />
        <Route path={"/stake-request"} element={<StakeSgt />} />
        <Route path={"/my-purchase"} element={<MyPurchase />} />
        <Route path={"/stake-detail"} element={<StakeDetail />} />
        <Route path={"/stake-success"} element={<StakeSuccess />} />
        <Route path={"/card-information"} element={<CardInfo />} />
        <Route path={"/commission"} element={<Commission />} />
        <Route path={"/affiliate"} element={<Affiliate />} />
        <Route
          path={"/affiliate/generate-links"}
          element={<AffiliateGenerate />}
        />
        {user?.country_code === CountryCode.indo && (
          <Route path={"/commission-detail"} element={<CommissionDetail />} />
        )}

        <Route path={"/confirm-phone"} element={<ConfirmPhone />} />
        <Route
          path={"/transaction-history/:type"}
          element={<TransactionHistory />}
        />
        {/*  for old router  */}
        <Route
          path={"/otc/wallet-detail/:type/:id"}
          element={<WalletDetail />}
        />
        <Route path={"/otc/withdraw"} element={<Withdraw />} />
        <Route
          path={"/otc/transaction-history/:type"}
          element={<TransactionHistory />}
        />
        {/*  all to main  */}
        <Route path={"/*"} element={<Navigate replace={true} to={"/"} />} />
      </Routes>
      <Footer />
    </>
  );
}
